import { CmsImage } from 'src/types'
import * as Styles from './PageTitle.style'
import Image from 'src/components/atoms/Image/Image'
import Container from 'src/components/_layout/Container/Container'
import { Title } from 'src/components/atoms/Title/Title'
import { AnimatePresence, motion } from 'framer-motion'
import Letters from 'src/components/atoms/Letters/Letters'
import RichText from 'src/components/atoms/RichText/RichText'

type PageTitleProps = {
    image: CmsImage
    title: string
}

const PageTitle: React.FC<PageTitleProps> = ({ image, title }) => {
    return (
        <Styles.Wrapper>
            <Image src={image.url} alt={image.alt} />
            <AnimatePresence exitBeforeEnter initial>
                <Styles.TitleFooter>
                    <Title
                        as={motion.div}
                        initial={{ opacity: 0, filter: 'blur(50px)' }}
                        animate={{ opacity: 1, filter: 'blur(0px)' }}
                        transition={{
                            duration: 1.5,
                        }}
                    >
                        <RichText
                            htmlString={title}
                            css={{
                                em: { fontFamily: '$secondary' },
                                '@smDown': { fontSize: '40px' },
                            }}
                            textVariant="titleBig"
                        />
                    </Title>
                </Styles.TitleFooter>
            </AnimatePresence>
        </Styles.Wrapper>
    )
}

export default PageTitle
